import { useQuery } from 'react-query';

import { getTrap } from 'api/traps/getTrap';

export const useGetTrap = (slug: string, trapId: number) => {
  const { data, refetch, isLoading } = useQuery('getTrap', () => getTrap(slug, trapId), {
    enabled: trapId > 0,
    refetchOnWindowFocus: false,
  });

  return { trapInfo: data, refetch, isLoading };
};

export default useGetTrap;
